import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useNavigateWithBase from "../hooks/useNavigateWithBase"; // ✅ 新しいフックをインポート
import axios from 'axios';
import '../CSS/EditCompany.css';

const EditCompany = () => {
  const { companyCode } = useParams();
  const navigate = useNavigateWithBase();
  const [companyData, setCompanyData] = useState({
    company_name: '',
    personal_id: '',
    personal_name: '',
    email: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  
  useEffect(() => {
    axios.post('https://cbo967jtmi.execute-api.ap-northeast-3.amazonaws.com/prod/api/companies', { action: 'fetchCompany', companyCode })
      .then(response => setCompanyData(response.data))
      .catch(error => console.error('データ取得エラー', error))
      .finally(() => setLoading(false));
  }, [companyCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`🔄 フィールド更新: ${name} = ${value}`);
    setCompanyData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSave = () => {
    setSaving(true);
  
    const requestData = {
      action: 'updateCompany',
      companyCode,
      company_name: companyData.company_name || '', // ✅ 値が空でも送る
      personal_name: companyData.personal_name || '',
      email: companyData.email || '',
    };
  
    axios.post('https://cbo967jtmi.execute-api.ap-northeast-3.amazonaws.com/prod/api/companies', requestData)
      .then(() => alert('保存完了'))
      .catch(error => console.error('保存エラー', error))
      .finally(() => setSaving(false));
  };

  const handlePasswordReset = () => {
    if (companyData.email) {
      axios.post('https://cbo967jtmi.execute-api.ap-northeast-3.amazonaws.com/prod/api/companies', {
        action: 'sendPasswordReset',
        email: companyData.email,
      })
        .then(() => alert('パスワード再送信しました'))
        .catch(error => console.error('パスワード送信エラー', error));
    }
  };

  return (
    <div className="company-edit-container">
      <h1>企業情報編集</h1>
      {loading && <p className="loading-message">データを読み込み中...</p>}
      {saving && <p className="saving-message">データを登録中...</p>}
      
      <label>企業コード（編集不可）</label>
      <input type="text" value={companyCode} disabled />
      
      <label>企業名</label>
      <input type="text" name="company_name" value={companyData.company_name} onChange={handleChange} />
      
      <label>代表責任者ID（編集不可）</label>
      <input type="text" value={companyData.personal_id} disabled />
      
      <label>代表責任者名</label>
      <input type="text" name="personal_name" value={companyData.personal_name} onChange={handleChange} />
      
      <label>代表責任者Eメール</label>
      <input type="email" name="email" value={companyData.email} onChange={handleChange} />
      
      <button onClick={handlePasswordReset} disabled={!companyData.email}>
        パスワード再送
      </button>
      
      <button onClick={handleSave} disabled={saving}>編集完了</button>
      <button onClick={() => navigate('/portal')} disabled={saving}>ポータルページに戻る</button>
    </div>
  );
};

export default EditCompany;
